// extracted by mini-css-extract-plugin
export default {"container":"checkboxes-choose-area_container__xLtN1"};